import {server_index} from './app.js'

let host_config = {
	test:[
		'http://pro7.2cccc.cc/'
	],
	production:[
		'http://bp.2cccc.cc/',
	],
}

let host = host_config[server_index][0];
let hosts = host_config[server_index];

export {
	host,
	hosts,
}